/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
  Button,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Cancel } from '../../media/images/Cancel';
import DraggableBidTable from '../../Common/DraggableTable.tsx/DraggableBidTable';
import { RootState } from '../../redux/rootState';
import { saveBidOrder } from '../Job/ScreenBidWorkSheetJob/redux/bidWorksheetSlice';
import { GetAssociatedBidsResponse } from '../Job/jobStarter/addJob/utils/types';
import { setLoader } from '../../redux/loaderSlice';

interface IReOrderUnitsModal {
  open: boolean;
  handleClose: () => void;
  handleData: () => void;
}
const Datatablestyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '500px',
  // height: 'fit-content',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: '6px 24px 24px 24px',
  height: 'auto',
  // minHeight: '350px',
  // '@media (max-width: 768px)': {
  //   p: '6px 6px 15px',
  //   height: 'auto',
  // },
};

export default function ReOrderBidsModal({
  open, handleClose, handleData,
}: IReOrderUnitsModal) {
  const dispatch = useDispatch();
  const { bidList } = useSelector((state:RootState) => state.jobStarterReducer);
  const { isLoading } = useSelector((state:RootState) => state.bidsReducer);
  const { jobId } = useParams();
  const [items, setItems] = useState<GetAssociatedBidsResponse[]>([]);
  const closeModal = () => {
    handleClose();
  };
  const callback = () => {
    handleData();
    handleClose();
  };
  const handleSave = () => {
    const pay = {
      JobId: jobId,
      Bids: items?.map((item, index) => ({
        BidId: item?.BidId,
        Order: index + 1,
      })),
    };
    dispatch(saveBidOrder({ pay, handleData: callback }));
  };
  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  return (
    <Modal
      open={open}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={Datatablestyle}>
        <div className="customerInfo_container flex-row">
          <div className="customerInfo">
            Re-order Bids
          </div>
          <div className="cancel-icon" onClick={() => closeModal()}>
            <Cancel />
          </div>
        </div>
        <div>
          <div className="draggable-header">BID ID  |  DATE CREATED</div>
          <DraggableBidTable data={bidList} items={items} setItems={setItems} />
        </div>
        <div className="save_and_next_div">
          <div>
            <Button className="button_cancel" onClick={closeModal}>Cancel</Button>
          </div>
          <div className="button_margin_left" style={{ marginTop: '20px' }}>
            <Button className="button_save_and_next" onClick={handleSave}>Save</Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
